export const TRANSCRIPTIONS_LIST_EMPTY_STATE_DELETED =
  'This meeting’s transcription was deleted and\nis no longer available.';

export const TRANSCRIPTIONS_LIST_EMPTY_STATE_UNAVAILABLE =
  'No transcription is available for this meeting\nbecause it wasn’t started.\nPlease enable transcription during the\nmeeting to generate one.';
